import React, { FC, useCallback } from 'react';
import { InstallChromeExtensionDialog } from '../../components/controls/InstallExtensionDialog/chrome/InstallExtensionDialog';
import { UIButton } from '../../components/controls/ui/UIButton/UIButton';
import { withInstallModal } from '../../hoc/withInstallModal';
import { onSetGongToken } from '../../scripts/apis/updateGongCookie';
import { InstallDialogProps } from '../../scripts/app';
import {
  EventSource,
  MessageAction,
} from '../../scripts/constants/message-action';
import { useBoolState } from '../../scripts/hooks';
import { useExtensionObserver } from '../../scripts/hooks/extension';
import { isChrome, logError } from '../../scripts/utils';
import { ConnectStep } from '../generic/Components';

const HybridInstallDialog = withInstallModal(
  ({ connectInProgress, handleOAuthInstall }) => {
    const [
      openInstallChromeExtensionDialog,
      setOpenInstallChromeExtensionDialog,
      setNotOpenInstallChromeExtensionDialog,
    ] = useBoolState(false);

    const extensionInstalled = useExtensionObserver();
    const unsupportedBrowser = !isChrome;

    const handleClickDone = useCallback(async () => {
      try {
        await handleOAuthInstall();

        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        window.addEventListener('message', onSetGongToken);
        window.postMessage({
          action: MessageAction.RefreshGongCookie,
          source: EventSource.WEB_APP,
        });
      } catch (error) {
        logError(error);
      }
    }, [handleOAuthInstall]);

    return (
      <>
        <ConnectStep step={1} title="Install Dashworks Extension">
          <p>
            Gong connection requires the Dashworks browser extension. Please
            contact support if you have questions.
          </p>
          {unsupportedBrowser ? (
            <p className="text-mahogany-20">
              Dashworks extension is only supported on Chrome. Please use Chrome
              to install the extension.
            </p>
          ) : (
            <UIButton
              disabled={extensionInstalled}
              onClick={setOpenInstallChromeExtensionDialog}
              size="large"
            >
              {extensionInstalled ? 'Extension installed' : 'Install'}
            </UIButton>
          )}
        </ConnectStep>
        <ConnectStep
          step={2}
          title="Grant Gong access by clicking Connect below"
        />
        <InstallChromeExtensionDialog
          onClose={setNotOpenInstallChromeExtensionDialog}
          open={openInstallChromeExtensionDialog}
        />
        {connectInProgress(handleClickDone, !extensionInstalled || !isChrome)}
      </>
    );
  }
);

export const AppInstallModal: FC<InstallDialogProps> = ({
  app,
  isOrg,
  onClose,
  open,
}) => {
  return (
    <HybridInstallDialog
      app={app}
      isOrg={isOrg}
      onClose={onClose}
      open={open}
    />
  );
};
